import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export type MissingEquipmentResponse = 'yes' | 'no' | 'na';
export type MissingEquipmentReason = 'not_in_stock' | 'unauthorized';
export type ServiceSatisfaction = 'excellent' | 'good' | 'fair' | 'poor';
export type StaffHelpfulness = 'yes' | 'no' | 'na';
export type ProcessEfficiency = 'excellent' | 'good' | 'fair' | 'poor' | 'na';

export interface CustomerFeedbackRecord {
  id?: string;
  transaction_log_id?: string | null;
  missing_equipment_response?: MissingEquipmentResponse;
  missing_equipment_reason?: MissingEquipmentReason | null;
  missing_equipment_details?: string | null;
  service_satisfaction?: ServiceSatisfaction;
  staff_helpfulness?: StaffHelpfulness;
  process_efficiency?: ProcessEfficiency;
  [key: string]: unknown;
}

export interface UpdateCustomerFeedbackResponse {
  feedback?: CustomerFeedbackRecord;
  message?: string;
}

export interface UpdateCustomerFeedbackInput {
  transactionLogId: string;
  missingEquipmentResponse: MissingEquipmentResponse;
  serviceSatisfaction: ServiceSatisfaction;
  staffHelpfulness: StaffHelpfulness;
  processEfficiency: ProcessEfficiency;
  missingEquipmentReason?: MissingEquipmentReason | null;
  missingEquipmentDetails?: string | null;
  customerName?: string;
  userEmail?: string;
}

export class CustomerFeedbackService {
  private readonly endpoint = API_CONFIG.ENDPOINTS.CUSTOMER_FEEDBACK;

  async updateFeedback({
    transactionLogId,
    missingEquipmentResponse,
    serviceSatisfaction,
    staffHelpfulness,
    processEfficiency,
    missingEquipmentReason,
    missingEquipmentDetails,
    customerName,
    userEmail,
  }: UpdateCustomerFeedbackInput): Promise<UpdateCustomerFeedbackResponse> {
    const payload: Record<string, unknown> = {
      missingEquipmentResponse,
      serviceSatisfaction,
      staffHelpfulness,
      processEfficiency,
      customerName,
      userEmail,
    };

    if (missingEquipmentReason !== undefined) {
      payload.missingEquipmentReason = missingEquipmentReason;
    }

    if (missingEquipmentDetails !== undefined) {
      payload.missingEquipmentDetails = missingEquipmentDetails;
    }

    return httpClient.put<UpdateCustomerFeedbackResponse>(
      `${this.endpoint}/${transactionLogId}`,
      payload,
    );
  }
}

export const customerFeedbackService = new CustomerFeedbackService();
